import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { formatMoneyWithSign } from '../../../helpers';

const OperationsSummaryCard = ({
  label,
  count,
  value,
  isWarning,
  loading,
  tooltipText,
}) => {
  const card = (
    <Stack
      sx={{
        bgcolor: 'white',
        borderRadius: 2,
        padding: { xs: 1, md: 1.5 },
        height: '100%',
        justifyContent: 'center',
      }}
      spacing={0.5}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
        <Typography variant="small_1" color="gray.A500" fontWeight={600} noWrap>
          {label}
        </Typography>
        {count != null && (
          <Typography variant="small_2" color="primary.A500" fontWeight={500}>
            {count}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
        {loading ? (
          <Skeleton variant="text" width={100} />
        ) : (
          <Typography
            variant="medium_1"
            fontWeight={500}
            color={isWarning ? 'error.A700' : 'gray.A700'}
            noWrap
          >
            {formatMoneyWithSign(value)}
          </Typography>
        )}
        {isWarning && (
          <ReportProblemOutlinedIcon sx={{ fontSize: 24, color: 'error.A700' }} />
        )}
      </Stack>
    </Stack>
  );

  if (!tooltipText) return card;
  return (
    <Tooltip title={tooltipText} placement="top">
      {card}
    </Tooltip>
  );
};

OperationsSummaryCard.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number, PropTypes.string]),
  isWarning: PropTypes.bool,
  loading: PropTypes.bool,
  tooltipText: PropTypes.string,
};

OperationsSummaryCard.defaultProps = {
  count: null,
  value: null,
  isWarning: false,
  loading: false,
  tooltipText: '',
};

export default OperationsSummaryCard;
